import React from 'react';

const Forms = () => (
  <div className="p-6">
    <h2 className="text-2xl font-bold mb-2">Forms</h2>
    <p className="text-gray-600">This is the Forms page.</p>
  </div>
);

export default Forms;
